const CustomerService = {
    getBillInvoiceData: function (billId, currency) {
        let url = '/customer/bills/' + billId + '/invoice-data';
        if (typeof currency !== 'undefined') url += '/' + currency;

        return $.ajax({
            async: true,
            url: url,
            method: 'GET',
            error: function (response) {
                console.log('Ajax error');
            }
        });
    },
    setDefaultCard: function (cardId, country) {
        return $.ajax({
            url: '/customer/cards/' + cardId + '/set-default',
            method: 'POST',
            data: {country},
            error: function (response) {
                console.log('Card not updated.');
            }
        });
    },
    addCredit: function (amount) {
        return $.ajax({
            url: '/customer/bills/add-credit',
            method: 'POST',
            data: {amount},
        });
    },
    getHistoryItem: function (itemId) {
        let url = '/customer/history/item/' + itemId + '';

        return $.ajax({
            async: true,
            url: url,
            method: 'GET',
            error: function (response) {
                console.log('Ajax error');
            }
        });
    },
    customerPayBill: function (billId, url) {
        return $.ajax({
            async: true,
            url: url || '/customer/pay/' + billId + '/bill',
            method: 'POST',
            error: function (response) {
                console.log('Ajax error');
            }
        });
    },
    getCustomerPayBill: function (billId, url) {
        return $.ajax({
            async: true,
            url: url || '/customer/pay/' + billId + '/bill',
            method: 'GET',
            error: function (response) {
                console.log('Ajax error');
            }
        });
    },
}

export {CustomerService};